import { soundchartsApi } from "./axios";

export const soundchartsEndpoints = {
  // Get song playlists with type filtering
  getSongPlaylistsByType: (
    uuid: string,
    platform: string,
    type: 'editorial' | 'algorithmic' | 'algotorial' | 'all',
    params: {
      offset?: number;
      limit?: number;
      sortBy?: string;
      sortOrder?: string;
      currentOnly?:number 
       }
  ) =>
    soundchartsApi.get(`song/${uuid}/playlist/current/${platform}`, {
      params: {
        type: type,
        offset: params.offset || 0,
        limit: params.limit || 100,
        sortBy: params.sortBy || "entryDate",
        sortOrder: params.sortOrder || "desc",
        currentOnly:params.currentOnly,
        // countryCodes: params.countryCode || []
      },
    }),

  // Get song by ISRC
  getSongByISRC: (isrc: string) => soundchartsApi.get(`/song/by-isrc/${isrc}`),
  getAudienceByUUIDAndPlatform: (uuid: string, platform: string,startDate:string,endDate:string) => 
    soundchartsApi.get(`/song/${uuid}/audience/${platform}` ,{
      params: {
        startDate: startDate,
        endDate: endDate
    }}),
};